<template>
  <div class="member-count-details">
    <template v-if="canShowCounters">
      <div class="member-count-details-inner">
        <i
          class="hi hi-12 hi-info-filled a-tooltip mr-8"
          :v-tooltip="tooltipOptions"
          :title="tooltipText"
        ></i>

        <span class="mr-4">Seats:</span>
        <span>{{ seatsMembersCount }} paid</span>
        <span class="occupied-count">{{ chargedMembersCount }} occupied</span>
        <span>{{ openSeats }} open</span>
      </div>

      <div
        v-if="hasCancellationScheduled"
        class="member-count-details-inner text-warning"
      >
        <i class="hi hi-12 hi-warning mr-8" />
        You cannot add more seats while your subscription is pending cancellation.
        {{ cancellationInstruction }}
      </div>
    </template>
    <template v-else>
      <div class="d-flex align-items-center">
        {{ chargedMembersCount }} of {{ membersCount }} members count toward your pricing plan

        <i
          class="hi hi-12 hi-info a-tooltip ml-5"
          :v-tooltip="tooltipOptions"
          :title="legacyTooltip"
        ></i>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'MemberCountDetails',
  props: {
    membersCount: {
      type: Number,
      required: true,
    },
    chargedMembersCount: {
      type: Number,
      required: true,
    },
    seatsMembersCount: {
      type: Number,
      required: true,
    },
    organization: {
      type: Object,
      required: true,
    },
    viewOnlyEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    legacyTooltip() {
      switch (this.planType) {
        case 'all_members':
        case 'per_user':
        case 'all_non_viewers':
          return this.viewOnlyEnabled
            ? `Viewers and View-only members do not count toward your ${this.planName || ''} plan`
            : `Viewers do not count toward your ${this.planName || ''} plan`;
        case 'legacy':
          return this.viewOnlyEnabled
            ? `Viewers, View-only members and members with time tracking disabled do not count towards your ${
                this.planName || ''
              } plan`
            : `Viewers and members with time tracking disabled do not count towards your ${this.planName || ''} plan`;
        case 'free':
          return 'All members count toward your plan';
        case 'trial':
          return this.viewOnlyEnabled
            ? 'Viewers and View-only members do not count toward your plan'
            : 'Viewers do not count toward your plan';
        default:
          return null;
      }
    },
    tooltipOptions() {
      return { placement: this.canShowCounters ? 'bottom' : 'top' };
    },
    tooltipText() {
      let text =
        'You can add more seats at any time. Paid seats are the total number of seats you are currently paying for. Any open seats will be filled automatically when new members are added. Any open seats will be removed automatically when a new pay period starts.';

      if (this.organization.billing_pending_quantities_update) {
        text = `Seat count will be updated within 24 hours to reflect the actual number of paid seats. ${text}`;
      }

      return text;
    },
    planName() {
      return this.organization.plan_name;
    },
    planType() {
      return this.organization.counting_model;
    },
    canShowCounters() {
      return this.organization.show_per_seat_ui;
    },
    hasCancellationScheduled() {
      return this.organization.cancellation_scheduled;
    },
    cancellationInstruction() {
      return this.organization.manual_cancellation
        ? 'To add more seats, first stop your plan cancellation.'
        : 'To add more seats, first pay all overdue invoices.';
    },
    openSeats() {
      const openSeats = this.seatsMembersCount - this.chargedMembersCount;

      return openSeats < 0 ? 0 : openSeats;
    },
  },
};
</script>
